import request from '@/utils/request'
import  qs from 'qs'
export function getProductList() {//创建
    return request({
        url: '/xxx/xxx',
        method: 'get',
    })
}
export function getProductTagTree() {//创建
    return request({
        url: '/department/tree',
        method: 'get',
    })
}

export function delProTagById(data) {//删除
    return request({
        url: '/department/del/'+data.id,
        method: 'post',
    })
}

export function createProTag(data) {//删除
    return request({
        url: '/department/save',
        method: 'post',
        data,
    })
}

export function updateProTag(data) {//编辑
    return request({
        url: '/department/update',
        method: 'post',
        data
    })
}

